/*
 ClioReview widget
 Build 1
 Selectors: #review-widget
*/

document.addEventListener('DOMContentLoaded', () => {
    const options = {
        endpoint:
            'https://api-cdn.yotpo.com/v1/widget/$app_key/products/$product_id/reviews.json',
        appkey: 'APNWxX3ImKb8kANkD7teFi4D8AlckZkL6tT7dKX8',
    };
    function handleErrors(response) {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response.json();
    }
    function scoreFormat(number, force_decimal = false) {
        let rounded = Math.round(number * 10) / 10;
        let score = force_decimal && rounded ? rounded.toFixed(1) : rounded;
        return score ? score : '?';
    }
    function scoreInt(number) {
        return number | 0;
    }
    function reviewList(response, stars = 0, update = false) {
        if (!response || !'reviews' in response || !response.reviews.length)
            return '';
        let html = '';
        response.reviews.forEach(function (review) {
            const date = new Date(review.created_at);
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            //<img src="${ window.rating_options.icons[scoreInt(review.score)] }" alt=""/>
            html += `<li>
        <figure>${review.user.display_name.charAt(0)}</figure>
        <div class="section">
          <h4>
            <span>${
                review.user.display_name
            } <i class="entypo-shield"></i></span> 
            <span>${review.score}/5</span>
            <span style="--stars: ${review.score}" class="star5"></span>
          </h4>
          <div>
            <h5>${review.title}</h5>
            <p>${review.content}</p>
            <small>${date.toLocaleDateString('it-IT', options)}</small>
          </div>
        </div>
      </li>`;
            if ('comment' in review && review.comment !== null) {
                const answerDate = new Date(review.comment.created_at);
                html += `<li class="answer">
          <figure></figure>
          <div class="section">
            <h4>TeamClio</h4>
            <div>
              <h5><i class="entypo-forward"></i> In risposta a ${
                  review.user.display_name
              }</h5>
              <blockquote>
                <h5>${review.title}</h5>
                <p>${review.content}</p>
              </blockquote>
              <p>${review.comment.content.replace(
                  /(?:\r\n|\r|\n)/g,
                  '<br>'
              )}</p>
              <small>${answerDate.toLocaleDateString('it-IT', options)}</small>
            </div>
          </div>
        </li>`;
            }
        });
        if (html) {
            const filteredTotal = stars
                ? response.bottomline.star_distribution[stars.toString()]
                : response.pagination.total;
            const nextpage =
                filteredTotal -
                    response.pagination.page * response.pagination.per_page >
                0
                    ? response.pagination.page + 1
                    : 0;
            if (update) {
                let loadMoreButton = document.querySelector('.review-loadmore');
                loadMoreButton.setAttribute('data-loadmore', nextpage);
                return html;
            } else {
                return `
        <div class="review-list">
          <ul>${html}</ul>
          <a data-stars="${stars}" data-loadmore="${nextpage}" class="review-loadmore button" href="#">${window.rating_options.labels.loadmore}</a>
        </div>`;
            }
        }
        return '';
    }
    function reviewStats(response) {
        if (!response || !'bottomline' in response) return '';
        const score = response.bottomline.average_score;
        let message =
            window.rating_options.labels.cta_text[
                window.rating_options.userType
            ];
        if (Array.isArray(message)) {
            message = message[window.rating_options.allowedUsers];
        }
        const html =
            `<div class="review-info">
      <h2>${window.rating_options.labels.title}</h2>
      <h3 class="big"><span style="--stars: ${score}" class="star5"></span><span><!--<img src="${
                window.rating_options.icons[scoreInt(score)]
            }" alt=""/>-->${scoreFormat(score, true)}</span></h3>
      <div class="review-product">
        <img src="${window.rating_options.image}" alt="${window.rating_options.title}" />
        <div>
          <h3>${window.rating_options.title}</h3>
          <p>${
              response.bottomline.total_review
                  ? window.rating_options.labels.subtitle.replace(
                        '$reviews',
                        response.bottomline.total_review
                    )
                  : window.rating_options.labels.subtitle_empty
          }</p>
          <p>${message
              .replace('$product', window.rating_options.title)
              .replace('$date', window.rating_options.orderDate)}</p>
        </div>
      </div>
      ` +
            (window.rating_options.userType >=
            window.rating_options.allowedUsers
                ? `<a class="button button-new-review" href="#">${window.rating_options.labels.cta_button}</a>`
                : '') +
            `</div>`;
        return html;
    }
    function starsDetail(response) {
        if (!response || !'bottomline' in response) return '';
        const total = response.bottomline.total_review;
        const stars =
            'star_distribution' in response.bottomline &&
            response.bottomline.star_distribution
                ? response.bottomline.star_distribution
                : { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
        const html = `<ul class="review-stars">
      <li data-stars="5" data-count="${stars['5']}" style="--progress: ${
            (stars['5'] / total) * 100
        }%"><strong>5 stelle <span style="--stars: 5" class="star5 gray"></span></strong><span>${
            stars['5']
        }</span><i></i></li>
      <li data-stars="4" data-count="${stars['4']}" style="--progress: ${
            (stars['4'] / total) * 100
        }%"><strong>4 stelle <span style="--stars: 4" class="star5 gray"></span></strong><span>${
            stars['4']
        }</span><i></i></li>
      <li data-stars="3" data-count="${stars['3']}" style="--progress: ${
            (stars['3'] / total) * 100
        }%"><strong>3 stelle <span style="--stars: 3" class="star5 gray"></span></strong><span>${
            stars['3']
        }</span><i></i></li>
      <li data-stars="2" data-count="${stars['2']}" style="--progress: ${
            (stars['2'] / total) * 100
        }%"><strong>2 stelle <span style="--stars: 2" class="star5 gray"></span></strong><span>${
            stars['2']
        }</span><i></i></li>
      <li data-stars="1" data-count="${stars['1']}" style="--progress: ${
            (stars['1'] / total) * 100
        }%"><strong>1 stella  <span style="--stars: 1" class="star5 gray"></span></strong><span>${
            stars['1']
        }</span><i></i></li>
    </ul>`;
        return html;
    }
    function lightWidget(response) {
        let position = document.querySelector('h2.vendor');
        const score = response.bottomline.average_score;
        if (position) {
            const html = `<a class="review-light" href="#review-widget">
        <span style="--stars: ${
            response.bottomline.average_score
        }" class="star5 middle"></span>
        <!--<img src="${
            window.rating_options.icons[scoreInt(score)]
        }" alt=""/>-->
        <strong>${scoreFormat(response.bottomline.average_score, true)}</strong>
        <span>(${response.bottomline.total_review} Recensioni)</span>
      </a>`;
            position.insertAdjacentHTML('beforebegin', html);
        }
    }
    function tabCounter(count = 0) {
        let counter = document.querySelector(
            'label[for="review-tab-all"] span'
        );
        counter.innerText = count;
    }
    function reviewCta() {
        let btns = document.querySelectorAll('.button-new-review');
        let input = document.getElementById('review-tab-new');
        btns.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                input.click();
            });
        });
    }
    function loadMore(url) {
        const button = document.querySelector('.review-loadmore');
        if (!button) return;
        const list = document.querySelector('.review-list > ul');
        button.addEventListener('click', function (e) {
            e.preventDefault();
            button.classList.add('loading');
            const page = parseInt(button.getAttribute('data-loadmore'));
            const stars = parseInt(button.getAttribute('data-stars'));
            const pageUrl =
                url + '&page=' + page + (stars ? '&star=' + stars : '');
            fetch(pageUrl, { method: 'GET' })
                .then(handleErrors)
                .then(function (data) {
                    if ('status' in data && data.status.code == 200) {
                        const response =
                            'response' in data ? data.response : false;
                        setTimeout(function () {
                            list.insertAdjacentHTML(
                                'beforeend',
                                reviewList(response, stars, true)
                            );
                            button.classList.remove('loading');
                        }, 900);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        });
    }
    function starFilters(url) {
        let filters = document.querySelectorAll('li[data-stars]');
        filters.forEach(function (filter) {
            filter.addEventListener('click', function (e) {
                e.preventDefault();
                const count = filter.getAttribute('data-count');
                if (count) {
                    const isActive = filter.classList.contains('active');
                    const stars = filter.getAttribute('data-stars');
                    const filteredUrl = isActive ? url : url + '&star=' + stars;
                    filter.classList.toggle('active');
                    filters.forEach(function (filterToDisable) {
                        if (
                            stars !== filterToDisable.getAttribute('data-stars')
                        ) {
                            filterToDisable.classList.remove('active');
                        }
                    });
                    fetch(filteredUrl, { method: 'GET' })
                        .then(handleErrors)
                        .then(function (data) {
                            if ('status' in data && data.status.code == 200) {
                                const response =
                                    'response' in data ? data.response : false;
                                const oldReviewList =
                                    document.querySelector('.review-list');
                                if (oldReviewList) {
                                    oldReviewList.remove();
                                }
                                const body =
                                    widget.querySelector('.review-all');
                                body.insertAdjacentHTML(
                                    'beforeend',
                                    reviewList(response, isActive ? 0 : stars)
                                );
                                loadMore(url);
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            });
        });
    }
    function buildWidget(widget, options) {
        const pid = window.rating_options.pid;
        const body = widget.querySelector('.review-all');
        if (!pid) return;
        const url =
            options.endpoint
                .replace('$app_key', options.appkey)
                .replace('$product_id', pid) +
            '?per_page=' +
            window.rating_options.reviewsPerPage;
        fetch(url, { method: 'GET' })
            .then(handleErrors)
            .then(function (data) {
                if ('status' in data && data.status.code == 200) {
                    const response = 'response' in data ? data.response : false;
                    widget.insertAdjacentHTML(
                        'beforeend',
                        reviewStats(response)
                    );
                    body.insertAdjacentHTML('beforeend', starsDetail(response));
                    body.insertAdjacentHTML('beforeend', reviewList(response));
                    lightWidget(response);
                    tabCounter(response.bottomline.total_review);
                    reviewCta();
                    starFilters(url);
                    loadMore(url);
                    structuredData(response.bottomline);
                }
            })
            .catch(function (error) {
                const widget = document.querySelector('#review-tab-all');
                const createnew = document.querySelector('#review-tab-new');
                createnew.click();
                widget.remove();
                console.log(error);
            });
    }
    function structuredData(reviews) {
        if (!parseInt(window.rating_options.price)) {
            return;
        }
        const aggregateRating =
            reviews.total_review > 0
                ? `"aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "${scoreFormat(reviews.average_score, true)}",
          "reviewCount": "${reviews.total_review}"
        },`
                : '';
        const script = `
    <script type="application/ld+json">
      {
        "@context": "http://schema.org/",
        "@type": "Product",
        "@id": "${window.rating_options.url}",
        "name": "${window.rating_options.title}",
        "url": "${window.rating_options.url}",
        "image": [ "${window.rating_options.imageBig}" ],
        "brand": {
          "@type": "Thing",
          "name": "ClioMakeUpShop"
        },
        ${aggregateRating}
        "offers": [
          {
            "@type" : "Offer",
            "sku": "${window.rating_options.sku}",
            "availability" : "http://schema.org/${
                window.rating_options.available ? 'InStock' : 'OutOfStock'
            }",
            "price" : "${window.rating_options.price}",
            "priceCurrency" : "EUR",
            "url" : "${window.rating_options.url}"
          }
        ],
        "description": "${window.rating_options.description}"
      }
    </script>`;
        document.head.insertAdjacentHTML('beforeend', script);
    }
    const widget = document.querySelector('#review-widget');
    buildWidget(widget, options);
});
